import React from 'react';
import { Award, Target, Users, TrendingUp } from 'lucide-react';

const AboutSection = () => {
  const stats = [
    { icon: Users, number: "5000+", label: "Students Enrolled" },
    { icon: Award, number: "1500+", label: "Successful Selections" },
    { icon: TrendingUp, number: "95%", label: "Success Rate" },
    { icon: Target, number: "10+", label: "Years Experience" }
  ];

  return (
    <section id="about" className="py-20 bg-gradient-to-b from-white to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            About <span className="text-blue-600">ZOOM ACADEMY</span>
          </h2>
          <div className="w-24 h-1 bg-yellow-400 mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Leading the way in entrance exam preparation and government job coaching in Hisar
          </p>
        </div>

        {/* Main Content */}
        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          {/* Image */}
          <div className="relative">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://customer-assets.emergentagent.com/job_98529d53-1c35-46ad-aba2-5200ea95c0d0/artifacts/3d3vq8dw_WhatsApp%20Image%202026-02-04%20at%2019.03.44.jpeg"
                alt="ZOOM Academy Classroom"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-green-600/30 to-transparent"></div>
            </div>
            <div className="absolute -bottom-6 -right-6 bg-gradient-to-br from-green-500 to-green-600 text-white p-6 rounded-xl shadow-xl">
              <p className="text-4xl font-bold">10+</p>
              <p className="font-semibold">वर्षों का अनुभव</p>
            </div>
          </div>

          {/* Content */}
          <div>
            <h3 className="text-3xl font-bold text-gray-900 mb-6">
              करियर बनाएं, भविष्य संवारें
            </h3>
            <p className="text-gray-700 mb-4 leading-relaxed">
              ZOOM ACADEMY हिसार का एक प्रमुख कोचिंग संस्थान है, जो कृषि, नर्सिंग, मत्स्य पालन और सरकारी प्रतियोगी परीक्षाओं में उत्कृष्टता प्राप्त करने की इच्छा रखने वाले छात्रों को असाधारण शिक्षा और मार्गदर्शन प्रदान करने के लिए समर्पित है।
            </p>
            <p className="text-gray-700 mb-6 leading-relaxed">
              गुणवत्तापूर्ण शिक्षा, व्यक्तिगत परामर्श और सफलता के सिद्ध ट्रैक रिकॉर्ड पर ध्यान केंद्रित करते हुए, हमने सैकड़ों छात्रों को शीर्ष संस्थानों में प्रवेश सुरक्षित करने और प्रतियोगी परीक्षाओं को पास करने के उनके सपनों को प्राप्त करने में मदद की है।
            </p>

            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-green-600 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <div className="w-2 h-2 bg-white rounded-full"></div>
                </div>
                <p className="text-gray-700"><span className="font-semibold">गुणवत्तापूर्ण शिक्षा:</span> प्रतियोगी परीक्षा कोचिंग में वर्षों के अनुभव वाले विशेषज्ञ संकाय</p>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-green-600 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <div className="w-2 h-2 bg-white rounded-full"></div>
                </div>
                <p className="text-gray-700"><span className="font-semibold">व्यक्तिगत मार्गदर्शन:</span> प्रत्येक छात्र के लिए व्यक्तिगत ध्यान और मार्गदर्शन</p>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-green-600 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <div className="w-2 h-2 bg-white rounded-full"></div>
                </div>
                <p className="text-gray-700"><span className="font-semibold">सिद्ध परिणाम:</span> टॉपर्स और सफल चयन का लगातार ट्रैक रिकॉर्ड</p>
              </div>
            </div>
          </div>
        </div>

        {/* Stats Section */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16">
          {stats.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <div key={index} className="bg-gradient-to-br from-green-500 to-green-600 rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300 text-center">
                <Icon className="w-10 h-10 text-white mx-auto mb-4" />
                <p className="text-3xl font-bold text-white mb-2">{stat.number}</p>
                <p className="text-white font-medium">{stat.label}</p>
              </div>
            );
          })}
        </div>

        {/* Director Section */}
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
          <div className="grid md:grid-cols-3 gap-8 items-center">
            <div className="md:col-span-1">
              <div className="aspect-square rounded-xl overflow-hidden shadow-lg">
                <img
                  src="https://customer-assets.emergentagent.com/job_zoom-education-1/artifacts/pk1r0bjc_IMG_3710.JPG.jpeg"
                  alt="Mr. Sumit Choudhary"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
            <div className="md:col-span-2">
              <h3 className="text-3xl font-bold text-gray-900 mb-2">Mr. Sumit Choudhary</h3>
              <p className="text-green-600 font-semibold mb-6">निदेशक, ZOOM ACADEMY</p>
              <p className="text-gray-700 mb-4 leading-relaxed italic">
                "ZOOM ACADEMY में, हम मानते हैं कि प्रत्येक छात्र में महानता प्राप्त करने की क्षमता है। हमारा मिशन केवल शिक्षा प्रदान करना नहीं है, बल्कि एक परिवर्तनकारी सीखने का अनुभव प्रदान करना है जो छात्रों को उनके चुने हुए करियर में सफलता के लिए तैयार करता है।"
              </p>
              <p className="text-gray-700 leading-relaxed">
                विभिन्न प्रतियोगी परीक्षाओं के लिए छात्रों को कोचिंग और मार्गदर्शन देने में 10 से अधिक वर्षों के अनुभव के साथ, श्री सुमित चौधरी ने अपना करियर इच्छुक पेशेवरों के भविष्य को आकार देने के लिए समर्पित किया है। किफायती, गुणवत्तापूर्ण शिक्षा की उनकी दृष्टि ने हिसार और आसपास के क्षेत्रों के सैकड़ों छात्रों को प्रतिष्ठित संस्थानों और सरकारी पदों में प्रवेश पाने के अपने सपनों को प्राप्त करने में मदद की है।
              </p>
              <div className="mt-6 space-y-2">
                <p className="text-gray-700"><span className="font-semibold text-green-600">विशेषज्ञता:</span> कृषि प्रवेश परीक्षा, सरकारी प्रतियोगी परीक्षा</p>
                <p className="text-gray-700"><span className="font-semibold text-green-600">अनुभव:</span> कोचिंग उद्योग में 10+ वर्ष</p>
                <p className="text-gray-700"><span className="font-semibold text-green-600">विजन:</span> सभी के लिए गुणवत्तापूर्ण शिक्षा सुलभ बनाना</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
